import { render } from "./CouponTable.vue?vue&type=template&id=f9afbece&scoped=true"
import script from "./CouponTable.vue?vue&type=script&lang=js"
export * from "./CouponTable.vue?vue&type=script&lang=js"

import "./CouponTable.vue?vue&type=style&index=0&id=f9afbece&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9afbece"]])

export default __exports__